import { useMutation } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../CommonUtils/urlWithParams';
import { httpBodyOptions } from '../../../CommonUtils/httpBodyOptions';
import { useClientId } from '../../../_hooks/useClientId';

interface InstitutionDTO {
  Linkable: number;
  Term: string;
  Value: string;
}

interface ListInstitutionsDTO {
  Data: InstitutionDTO[];
}

const listInstitutions = (clientId: number) => (term: string): Promise<ListInstitutionsDTO> =>
  authFetch(
    urlWithParams(`/Consumer/AutoComplete/ListInstitutions`, {
      clientId,
    }),
    {
      method: 'POST',
      ...httpBodyOptions({
        term,
      }),
    },
  );

export const useListInstitutionMutation = () => {
  const clientId = useClientId();

  return useMutation(listInstitutions(clientId));
};
